class LocalLang {
     Get = () => {
        return localStorage.getItem('lang')
    }
     Set = (lang) => {
        return localStorage.setItem('lang', JSON.stringify(lang))
    }
}
export default new LocalLang